import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Picker, Item } from '@adobe/react-spectrum';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

import { Wrap, Input, ButtonChangeCalendar, DivArrows } from './styles';
import InputDate from './InputDate';

const Filters = ({
  viewOptions,
  setViewOptions,
  startDate,
  setStartDate,
  handleDateChange,
}) => {
  async function selectViewOption(viewBy) {
    const selected = viewOptions.elements.find(e => e.id === viewBy).value;

    setViewOptions({ ...viewOptions, selected });
  }

  return (
    <Wrap>
      <Input>
        <Picker
          label="View by"
          defaultSelectedKey="423ab563-1d41-472f-a8b1-890cfc6bc482"
          onSelectionChange={selected => selectViewOption(selected)}
        >
          {viewOptions.elements.map(item => (
            <Item key={`${item.id}`}>{item.name}</Item>
          ))}
        </Picker>
      </Input>
      <Input>
        <InputDate
          viewBy={viewOptions.selected}
          startDate={startDate}
          setStartDate={setStartDate}
        />
        <DivArrows>
          <ButtonChangeCalendar onClick={() => handleDateChange('subtract')}>
            <ChevronLeft />
          </ButtonChangeCalendar>
          <ButtonChangeCalendar onClick={() => handleDateChange('add')}>
            <ChevronRight />
          </ButtonChangeCalendar>
        </DivArrows>
      </Input>
    </Wrap>
  );
};

Filters.propTypes = {
  setViewOptions: PropTypes.func.isRequired,
  viewOptions: PropTypes.shape({
    selected: PropTypes.number,
    elements: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
  handleDateChange: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  setStartDate: PropTypes.func.isRequired,
};

export default Filters;
